import { useCurrentUser } from '../hooks/useCurrentUser';
import { cs } from './cs';
import { en } from './en';
import { LanguageKeys } from './keys';

const languages = {
  cs,
  en,
};

export const defaultLang = 'cs' as const;

export function useCurrentLanguage(): LanguageKeys {
  const loggedUser = useCurrentUser();

  const language = loggedUser?.language || defaultLang;

  if (languages[language]) {
    return languages[language];
  }

  return languages[defaultLang];
}

export function useLoggedUserLanguage() {
  const loggedUser = useCurrentUser();

  const language = loggedUser?.language || defaultLang;

  return language;
}

export const activeLang: LanguageKeys = languages[defaultLang];
